<div class="container-fluid p-3">
  <mat-card>
    <mat-card-header class="pb-0">
      <mat-card-title>Carga Masiva de Metas</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <div class="row">
        <div class="col-12 col-md-12">
          <input type="file" #fileInput (change)="onFileSelected($event)" accept=".xlsx,.xls" style="display: none">
          <div class="d-flex gap-2 flex-column flex-md-row">
            <button mat-flat-button color="primary" (click)="fileInput.click()">
              <mat-icon>upload_file</mat-icon>
              Seleccionar Archivo
            </button>
            <button mat-flat-button color="warn" [disabled]="!selectedFile" (click)="procesarArchivo()">
              <mat-icon>check_circle</mat-icon>
              Procesar Archivo
            </button>
            <button mat-flat-button color="basic" [disabled]="!selectedFile" (click)="cancelarSeleccionArchivo()">
              <mat-icon>close</mat-icon>
              Cancelar
            </button>
            <span class="ms-2 align-self-center" *ngIf="selectedFile">
              {{selectedFile.name}}
            </span>
          </div>
          <div class="mt-2">
            <small class="text-muted">
              El archivo Excel debe contener las columnas: periodo, c_vend, valor_meta
            </small>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Panel de Instrucciones y Plantilla -->
  <mat-expansion-panel class="mb-3 mt-3">
    <mat-expansion-panel-header>
      <mat-panel-title>
        <mat-icon class="mr-2">help_outline</mat-icon>
        Instrucciones de Carga
      </mat-panel-title>
    </mat-expansion-panel-header>

    <div class="instructions-container">
      <!-- Descripción -->
      <div class="mb-3">
        <h3 class="text-lg font-semibold mb-2">Formato del Archivo</h3>
        <p class="text-gray-600 mb-4">
          Para cargar las metas de vendedor, utilice la plantilla Excel proporcionada.
          Asegúrese de seguir el formato especificado para cada campo.
        </p>
      </div>

      <!-- Tabla de Campos -->
      <div class="mb-4">
        <table mat-table [dataSource]="camposRequeridos" class="w-full">
          <ng-container matColumnDef="campo">
            <th mat-header-cell *matHeaderCellDef>Campo</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.campo}}</td>
          </ng-container>

          <ng-container matColumnDef="formato">
            <th mat-header-cell *matHeaderCellDef>Formato</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.formato}}</td>
          </ng-container>

          <ng-container matColumnDef="ejemplo">
            <th mat-header-cell *matHeaderCellDef>Ejemplo</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.ejemplo}}</td>
          </ng-container>

          <ng-container matColumnDef="descripcion">
            <th mat-header-cell *matHeaderCellDef>Descripción</th>
            <td mat-cell *matCellDef="let elemento">{{elemento.descripcion}}</td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnasTabla"></tr>
          <tr mat-row *matRowDef="let row; columns: columnasTabla;"></tr>
        </table>
      </div>

      <!-- Notas Importantes -->
      <div class="mb-4">
        <h4 class="text-md font-semibold mb-2">Notas Importantes:</h4>
        <ul class="list-disc pl-5 text-gray-600">
          <li>No modificar el orden de las columnas</li>
          <li>No dejar campos vacíos</li>
          <li>Los valores de meta deben ser números positivos</li>
          <li>El periodo debe ser una fecha válida en formato YYYYMM</li>
        </ul>
      </div>

      <!-- Botón de Descarga -->
      <div class="flex justify-start">
        <a mat-raised-button color="primary" href="/assets/templates/metavendedor/plantilla_metas.xlsx"
          download="plantilla_metas_vendedor.xlsx" class="flex items-center">
          <mat-icon class="mr-2">download</mat-icon>
          Descargar Plantilla Excel
        </a>
      </div>
    </div>
  </mat-expansion-panel>

  <!-- Formulario de Metas -->
  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>{{ isEditing ? 'Editar' : 'Crear' }} Meta de Vendedor</mat-card-title>
    </mat-card-header>
    <mat-card-content class="pt-3">
      <form [formGroup]="metaForm" (ngSubmit)="onSubmit()">
        <div class="row g-3 align-items-center">
          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100"
              [matTooltip]="isEditing ? 'No se puede modificar el periodo en modo edición' : ''"
              [matTooltipPosition]="'above'"
              [matTooltipDisabled]="!isEditing">
              <mat-label>Periodo</mat-label>
              <mat-select formControlName="periodo" required>
                <mat-option *ngFor="let periodo of periodosAbiertos" [value]="periodo.periodo">
                  {{periodo.periodo}}
                </mat-option>
              </mat-select>
              <mat-error *ngIf="metaForm.get('periodo')?.hasError('required')">
                El periodo es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-6 col-sm-12">
            <mat-form-field appearance="outline" class="w-100"
              [matTooltip]="isEditing ? 'No se puede modificar el vendedor en modo edición' : ''"
              [matTooltipPosition]="'above'"
              [matTooltipDisabled]="!isEditing">
              <mat-label>Vendedor</mat-label>
              <input type="text" matInput [formControl]="vendedorControl" [matAutocomplete]="auto"
                     [attr.disabled]="isEditing ? '' : null" (focus)="mostrarTodosLosVendedores()"
                     (blur)="onVendedorBlur()" #vendedorInput>
              <button mat-icon-button matSuffix (click)="mostrarTodosLosVendedores()" type="button" 
                      [disabled]="isEditing">
                <mat-icon>search</mat-icon>
              </button>
              <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayVendedor" (optionSelected)="onVendedorSelected($event)">
                <mat-option *ngFor="let vendedor of vendedoresFiltrados | async" [value]="vendedor">
                  {{vendedor.codigo_vendedor}} - {{vendedor.nombre_vendedor}}
                </mat-option>
              </mat-autocomplete>
              <mat-error *ngIf="metaForm.get('c_vend')?.hasError('required')">
                El vendedor es requerido
              </mat-error>
            </mat-form-field>
          </div>

          <div class="col-md-2 col-sm-12">
            <mat-form-field appearance="outline" class="w-100">
              <mat-label>Valor Meta</mat-label>
              <input matInput type="text" formControlName="valor_meta" required
                [value]="metaForm.get('valor_meta')?.value | currency:'COP':'symbol-narrow':'1.0-0'"
                (input)="onValorMetaInput($event)">
              <mat-error *ngIf="metaForm.get('valor_meta')?.hasError('required')">
                El valor de la meta es requerido
              </mat-error>
              <mat-error *ngIf="metaForm.get('valor_meta')?.hasError('min')">
                El valor debe ser mayor a 0
              </mat-error>
            </mat-form-field>
          </div>
        </div>

        <div class="d-flex gap-2 mt-3 justify-content-end">
          <button mat-flat-button color="primary" type="submit" [disabled]="!metaForm.valid || isLoading"
            class="btn btn-primary">
            <mat-spinner diameter="20" *ngIf="isLoading"></mat-spinner>
            <span *ngIf="!isLoading">{{ isEditing ? 'Actualizar' : 'Guardar' }}</span>
          </button>
          <button mat-flat-button type="button" (click)="onCancel()" *ngIf="isEditing" [disabled]="isLoading"
            class="btn btn-secondary">
            Cancelar
          </button>
        </div>
      </form>
    </mat-card-content>
  </mat-card>

  <mat-card class="mt-3">
    <mat-card-header class="pb-0">
      <mat-card-title>Lista de Metas de Vendedor</mat-card-title>
    </mat-card-header>


    <mat-card-content class="pt-3">
      <!-- Barra de búsqueda -->
      <div class="row mb-3">
        <div class="col-md-4 col-sm-12 mb-2 mb-sm-0">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Buscar</mat-label>
            <input matInput [formControl]="searchControl" placeholder="Buscar por vendedor...">
            <mat-icon matSuffix class="text-dark">search</mat-icon>
          </mat-form-field>
        </div>
        <div class="col-md-4 col-sm-12">
          <mat-form-field appearance="outline" class="w-100">
            <mat-label>Filtrar por Período</mat-label>
            <mat-select [formControl]="periodoFilterControl">
              <mat-option>Todos</mat-option>
              <mat-option *ngFor="let periodo of periodos" [value]="periodo.periodo">
                {{periodo.periodo}} ({{periodo.estadoperiodo}})
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>


      <div class="table-responsive">
        <table mat-table [dataSource]="dataSource" class="table w-100">
          <ng-container matColumnDef="periodo">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;font-size: 11px;">Periodo</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{element.periodo}}
              <mat-icon *ngIf="!isPeriodoAbierto(element.periodo)" 
                       matTooltip="Periodo cerrado"
                       class="text-warning" 
                       style="font-size: 16px; height: 16px; width: 16px; margin-left: 4px; vertical-align: middle;">
                lock
              </mat-icon>
            </td>
          </ng-container>

          <ng-container matColumnDef="c_vend">
            <th mat-header-cell *matHeaderCellDef style="width: 35%;font-size: 11px;">Vendedor</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{getVendedorNombre(element.c_vend)}}</td>
          </ng-container>

          <ng-container matColumnDef="valor_meta">
            <th mat-header-cell *matHeaderCellDef style="width: 20%;font-size: 11px;">Valor Meta</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">{{element.valor_meta | number:'1.0-0'}}</td>
          </ng-container>

          <ng-container matColumnDef="meta_recalculada">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;font-size: 11px;">Meta Recalculada</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{ element.meta_recalculada | number:'1.0-0' }}
            </td>
          </ng-container>

          <ng-container matColumnDef="dias_ausentismos">
            <th mat-header-cell *matHeaderCellDef style="width: 10%;font-size: 11px;">Días Ausentismos</th>
            <td mat-cell *matCellDef="let element" style="vertical-align: middle; font-size: 11px;">
              {{ element.dias_ausentismos }}
            </td>
          </ng-container>

          <ng-container matColumnDef="acciones">
            <th mat-header-cell *matHeaderCellDef style="width: 20% ;font-size: 13px;" class="text-center">Acciones</th>
            <td mat-cell *matCellDef="let element" class="text-center" style="vertical-align: middle;">
              <div style="display: flex; justify-content: center; gap: 4px;">
                <button mat-icon-button 
                        [disabled]="!isPeriodoAbierto(element.periodo)"
                        (click)="editarMeta(element)"
                        [matTooltip]="isPeriodoAbierto(element.periodo) ? 'Editar' : 'No se puede editar un registro de un periodo cerrado'">
                  <mat-icon [ngClass]="{'text-dark': isPeriodoAbierto(element.periodo)}">edit</mat-icon>
                </button>
                <button mat-icon-button 
                        [disabled]="!isPeriodoAbierto(element.periodo)"
                        (click)="eliminarMeta(element)"
                        [matTooltip]="isPeriodoAbierto(element.periodo) ? 'Eliminar' : 'No se puede eliminar un registro de un periodo cerrado'">
                  <mat-icon [ngClass]="{'text-dark': isPeriodoAbierto(element.periodo)}">delete</mat-icon>
                </button>
                <button mat-icon-button matTooltip="Ver detalles" (click)="verDetalles(element)">
                  <mat-icon class="text-dark">info</mat-icon>
                </button>
              </div>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="['periodo', 'c_vend', 'valor_meta', 'meta_recalculada', 'dias_ausentismos', 'acciones']; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: ['periodo', 'c_vend', 'valor_meta', 'meta_recalculada', 'dias_ausentismos', 'acciones'];"></tr>

          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell text-center" [attr.colspan]="displayedColumns.length" style="padding: 20px;">
              No se encontraron registros
            </td>
          </tr>
        </table>

        <mat-paginator [length]="totalItems" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25, 100]"
          [pageIndex]="currentPage" showFirstLastButtons aria-label="Seleccionar página">
        </mat-paginator>

      </div>


    </mat-card-content>
  </mat-card>
</div>